import 'alpinejs';

import wire_replace from '@leanadmin/wire-replace';

window.Livewire.hook(...wire_replace);

import Swiper, {Autoplay} from "swiper";
import 'swiper/swiper-bundle.css';

Swiper.use([Autoplay]);
window.Swiper = Swiper;
